module.exports = __webpack_public_path__ + "static/media/close-black-large.88012584.svg";